import React, {
  createContext,
  useState,
  useContext,
  useCallback,
  useMemo,
} from "react";

// Create Context
const LoaderContext = createContext({
  isLoading: false,
  homeReady: false,
  showLoader: () => {},
  hideLoader: () => {},
  markHomeReady: () => {},
});

// Provider Component
export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  // Home page ka pehla data aa gaya? (initial loader isi ka wait karta hai)
  const [homeReady, setHomeReady] = useState(false);

  // Function to toggle loader visibility
  const showLoader = useCallback(() => setIsLoading(true), []);

  const hideLoader = useCallback(
    () =>
      setTimeout(function () {
        setIsLoading(false);
      }, 2000),
    [],
  );

  const markHomeReady = useCallback(() => setHomeReady(true), []);

  const value = useMemo(
    () => ({ isLoading, homeReady, showLoader, hideLoader, markHomeReady }),
    [isLoading, homeReady, showLoader, hideLoader, markHomeReady],
  );

  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
};

// Custom Hook to use the Loader Context
export const useLoader = () => useContext(LoaderContext);
